module.exports = __webpack_public_path__ + "static/media/3.3601e45a.JPG";